import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import ActionCarousel from "@/components/ActionCarousel";
import { getTerms, termsSpeciesKeyFromSlug } from "@/lib/speciesTerms";

const buildBreedingCards = (speciesSlug) => {
  const key = termsSpeciesKeyFromSlug(speciesSlug);
  const { male, female } = getTerms(key);

  return [
    {
      title: `${male} Services`,
      actions: [
        { label: `Find a ${male}`, href: `/${speciesSlug}/breeding/find?role=male` },
        { label: `Register as a ${male}`, href: `/${speciesSlug}/breeding/register?role=male` },
      ],
    },
    {
      title: `${female} Services`,
      actions: [
        { label: `Find a ${female}`, href: `/${speciesSlug}/breeding/find?role=female` },
        { label: `Register as a ${female}`, href: `/${speciesSlug}/breeding/register?role=female` },
      ],
    },
  ];
};

const BrowseBreeding = () => {
  const location = useLocation();
  const species = location.pathname.split('/')[2]; // /browse/:species/breeding
  const cards = useMemo(() => buildBreedingCards(species), [species]);

  return (
    <div className="pt-24 pb-16 px-6 md:px-12 min-h-screen bg-[#050505]">
      <div className="max-w-7xl mx-auto">
        <ActionCarousel subtitle="Breeding" title="Breeding Services" cards={cards} />
      </div>
    </div>
  );
};

export default BrowseBreeding;
